var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"grid-column"},[_c('li',[_vm._v(_vm._s(_vm.columnHeader))]),_vm._v(" "),_vm._l((_vm.data),function(iterator,index){return _c('li',{key:index},[_c('nuxt-link',{attrs:{"to":_vm.$prismic.linkResolver(iterator.link)}},[_vm._v(_vm._s(iterator.text))])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }